// utils/cryptoUtils.js
import CryptoJS from 'crypto-js';

const SECRET_KEY = 'plot_management_secret_key';

export const encrypt = (text: string) => {
    return CryptoJS.AES.encrypt(text, SECRET_KEY).toString();
};

export const decrypt = (cipherText: string) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
};
